// components/ai/ImproveAIButton.tsx

import { WandSparkles } from "lucide-react";
import React from "react";
import { useSelector } from "react-redux";

import { isAIEnabled } from "../../../../src/features/configs/logic/Slice";
import DocumentTooltip from "../../../../src/features/documentManagement/components/DocumentTooltip";
import { cn } from "../../../lib/utils";
import ButtonV2 from "../button/v2";
import { renderButtonContent } from "./generateAIButton";

interface ImproveAIButtonProps {
  onClick?: () => void;
  loading?: boolean;
  disabled?: boolean;
}

const ImproveAIButton: React.FC<ImproveAIButtonProps> = ({
  onClick,
  loading = false,
  disabled = false,
}) => {
  const aiEnabled = useSelector(isAIEnabled);
  const isButtonDisabled = disabled || !aiEnabled;

  const button = (
    <ButtonV2
      variant="ai-gradient"
      size="md"
      className={cn(
        "border-gray-200 disabled:cursor-not-allowed disabled:opacity-80",
      )}
      onClick={onClick}
      disabled={isButtonDisabled}
      aria-busy={loading}
    >
      {renderButtonContent(
        "Improve with AI",
        "Improving with AI",
        loading,
        WandSparkles,
      )}
    </ButtonV2>
  );

  if (!aiEnabled) {
    return (
      <DocumentTooltip content="AI features currently disabled due to lack of tenant integrations.">
        <span className="inline-flex">{button}</span>
      </DocumentTooltip>
    );
  }

  return button;
};

export default ImproveAIButton;
